/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { all_routes } from "../../Router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsLoggedIn,
  loggedInUser,
  logout,
  changeLocation,
  changeCompany,
  changeToAllCompany,
} from "../../core/redux/slice/authSlice";
import Swal from "sweetalert2";
import { useGetLocationQuery } from "AppQuries/master/Location/location";
import { useGetUserCompaniesQuery } from "AppQuries/setting/company-settings";
import {
  useGetCompanyQuery,
  useGetCompanyMutation,
} from "AppQuries/company/get-company";
import { toast } from "core/Operations/toast";
import { requestPermission, listenNotification } from "notification";
import { Bell } from "react-feather";
import { useLogoutMutation } from "AppQuries/login/login";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";

import {
  useClearAllNotificationsMutation,
  useGetAllNotificationsQuery,
} from "AppQuries/notification/notification";
import { format, formatDistanceToNow } from "date-fns";
import { getNotificationURL } from "core/Operations/getNofiticationURL";
import { getNotifications } from "core/redux/slice/notification";
import LoadingSpinner from "Components/UI/LoadingSpinner";
const ALL_COMPANIES = 0;

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const route = all_routes;

  const userData = useSelector(loggedInUser);
  const isLoggedIn = useSelector(selectIsLoggedIn);

  const { mutate: logoutMutation } = useLogoutMutation();
  const { mutate: clearAllNotification } = useClearAllNotificationsMutation();
  const { mutate: getCompanyMutate } = useGetCompanyMutation();
  const notifications = useSelector(getNotifications);
  // const { data: notifications, refetch: getNotifications } =
  //   useGetAllNotificationsQuery({
  //     companyCode: userData?.companyCode,
  //     fromDate: format(new Date(), "yyyy-MM-dd"),
  //     toDate: format(new Date(), "yyyy-MM-dd"),
  //     userId: userData?.userID,
  //     status: true,
  //   });

  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    userData?.selectedCompanyCode,
  );

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [toggle, SetToggle] = useState(false);

  // NOTIFICATION
  useEffect(() => {
    requestPermission();
    if (userData) {
      listenNotification(dispatch, userData);
    }
  }, [dispatch, userData]);

  // END NOTIFICATION

  /* ===========================
     DATA FETCHING
  ============================ */

  const { data: companyList = [] } = useGetUserCompaniesQuery({
    userId: userData?.userID,
  });

  const companies = [
    { companyCode: ALL_COMPANIES, companyName: "All Companies" },
    ...companyList,
  ];

  const { data: locationsData = [], refetch: getLocations } =
    useGetLocationQuery({
      companyCode:
        userData?.selectedCompanyCode !== ALL_COMPANIES
          ? userData?.selectedCompanyCode
          : 0,
    });

  const locations = [
    { locationCode: "All", locationName: "All Locations" },
    ...locationsData,
  ];

  const {
    data: companyDetails = [],
    refetch: getCompany,
    isLoading,
    isFetching,
  } = useGetCompanyQuery(
    { companyCode: userData?.selectedCompanyCode, isAll: false },
    { enabled: false },
  );

  const handleCompanyChange = useCallback(
    (company) => {
      const loadCompany = async (cc) => {
        // const res = await getCompany({
        //   companyCode: selectedCompanyCode,
        //   isAll: false,
        // });

        const payload = {
          isAll: false,
          clientId: null,
          packageID: null,
          companyCode: cc,
        };

        getCompanyMutate(payload, {
          onSuccess: (res) => {
            if(Array.isArray(res) && res?.length > 0) {
              setSelectedCompanyCode(company.companyCode);
              dispatch(changeCompany({ companyDetails: res[0] }));
              navigate(all_routes.dashboard, { replace: true });
            }
            // console.log("Single Company selected", cc);
            // console.log(res);
          },
          onError: (error) => {
            console.error("Error fetching company details:", error);
            toast.error("Unable to load company details");
          },
        });

        // console.log("Single Company selected", cc);
        // console.log(res);

        // if (res?.isSuccess && res?.data?.length) {
        //   setSelectedCompanyCode(company.companyCode);
        //   dispatch(changeCompany({ companyDetails: res.data[0] }));
        //   navigate(all_routes.dashboard, { replace: true });
        // }
        // else {
        //   toast.error("Unable to load company details");
        // }
      };

      Swal.fire({
        title: "Confirm company change?",
        text: "Are you sure you want to switch company?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Change",
      }).then((res) => {
        if (res.isConfirmed) {
          console.log("company.companyCode", company.companyCode);
          const cc = company.companyCode;
          setSelectedCompanyCode(company.companyCode);
          if (company.companyCode !== ALL_COMPANIES) {
            getLocations();

            loadCompany(cc);
          } else if (company.companyCode === ALL_COMPANIES) {
            console.log("All Companies selected");
            setSelectedCompanyCode(company.companyCode);
            dispatch(changeToAllCompany({ isAllCompanies: true }));
            navigate(all_routes.dashboard, { replace: true });
          }
        }
      });
    },
    [getLocations, dispatch, navigate], 
  );

  // const handleCompanyChange = useCallback(
  //   (company) => {
  //     Swal.fire({
  //       title: "Confirm company change?",
  //       text: "Are you sure you want to switch company?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes, Change",
  //     }).then((res) => {
  //       if (res.isConfirmed) {
  //         setSelectedCompanyCode(company.companyCode);

  //         if (company.companyCode !== ALL_COMPANIES) {
  //           getLocations();
  //           const loadCompany = async () => {
  //             console.log("Loading company details for:", company.companyCode);
  //             const res = await getCompany({
  //               companyCode: company.companyCode,
  //               isAll: false,
  //             });

  //             if (res?.isSuccess && res?.data?.length) {
  //               dispatch(changeCompany({ companyDetails: res.data[0] }));
  //               navigate(all_routes.dashboard, { replace: true });
  //               // navigate(0);
  //             } else {
  //               toast.error("Unable to load company details");
  //             }
  //           };

  //           loadCompany();
  //         } else if (company.companyCode === ALL_COMPANIES) {
  //           dispatch(changeToAllCompany({ isAllCompanies: true }));
  //           navigate(all_routes.dashboard, { replace: true });
  //         }

  //         // setTimeout(() => navigate(0), 1000);
  //       }
  //     });
  //   },
  //   [setSelectedCompanyCode],
  // );

  /* ===========================
     COMPANY EFFECTS
  ============================ */

  // // Single company
  // useEffect(() => {
  //   getLocations();
  //   if (!selectedCompanyCode || selectedCompanyCode === ALL_COMPANIES) return;

  //   const loadCompany = async () => {
  //     console.log("Loading company details for:", selectedCompanyCode);
  //     const res = await getCompany({
  //       companyCode: selectedCompanyCode,
  //       isAll: false,
  //     });

  //     if (res?.isSuccess && res?.data?.length) {
  //       dispatch(changeCompany({ companyDetails: res.data[0] }));
  //       navigate(all_routes.dashboard, { replace: true });
  //       // navigate(0);
  //     } else {
  //       toast.error("Unable to load company details");
  //     }
  //   };

  //   loadCompany();
  // }, [selectedCompanyCode]);

  // // All companies
  // useEffect(() => {
  //   if (selectedCompanyCode !== ALL_COMPANIES) return;

  //   dispatch(changeToAllCompany({ isAllCompanies: true }));
  //   navigate(all_routes.dashboard, { replace: true });
  //   // navigate(0);
  // }, [selectedCompanyCode]);

  /* ===========================
     LOCATION CHANGE
  ============================ */

  const handleLocationChange = (locationCode) => {
    Swal.fire({
      title: "Confirm location change?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Change",
    }).then((res) => {
      if (res.isConfirmed) {
        dispatch(changeLocation(locationCode));
        setTimeout(() => navigate(0), 1000);
      }
    });
  };

  /* ===========================
     LOGOUT
  ============================ */

  const handleLogout = () => {
    const payload = {
      userID: userData?.userID,
      companyCode: userData?.companyCode,
      deviceId: userData?.deviceId,
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      status: false,
    };
    logoutMutation(payload);
    dispatch(logout());
    toast.warning("Logged out successfully");
    setTimeout(() => navigate("/Login", { replace: true }), 800);
  };

  /* ===========================
     FULLSCREEN
  ============================ */

  useEffect(() => {
    const handler = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  let pathname = window.location.pathname;

  useEffect(() => {
    if (pathname === "/PayrollV2/Attendance/TimeLog" && !toggle) {
      // if (pathname === "/PayrollLive/Attendance/TimeLog" && !toggle) {
      handlesidebar();
    }
  }, [pathname]);

  useEffect(() => {
    const handler = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  // const exclusionArray = [
  //   "/reactjs/template/dream-pos/index-three",
  //   "/reactjs/template/dream-pos/index-one",
  // ];
  // if (exclusionArray.indexOf(window.location.pathname) >= 0) {
  //   return null;
  // }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  // const toggleFullscreen = () => {
  //   if (!document.fullscreenElement) {
  //     document.documentElement.requestFullscreen();
  //   } else {
  //     document.exitFullscreen();
  //   }
  // };

  /* ===========================
     RENDER
  ============================ */

  const clearAllNotifications = () => {
    clearAllNotification(
      {
        userID: userData?.userID,
        companyCode: userData?.companyCode,
      },
      {
        onSuccess(data) {
          if (data?.response === true) {
            toast.success("Notifications cleared Successfully!");
            // getNotifications();
          } else {
            toast.error(data?.errorMessage);
          }
        },
        onError(error) {
          toast.error(error.message || "Something went wrong.");
        },
      },
    );
  };

  // if(isLoading || isFetching) return <LoadingSpinner />
  return (
    <>
      <div className="header">
        {/* Logo */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/dashboard" className="logo logo-normal">
            <ImageWithBasePath src="assets/img/logo.jpeg" alt="img" />
            {/* <img src={`data:image/png;base64,${userData?.companyLogo}`} alt="Logo" /> */}
          </Link>
          <Link to="/dashboard" className="logo logo-white">
            <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
            {/* <img src={`data:image/png;base64,${userData?.companyLogo}`} alt="Logo" /> */}
          </Link>
          <Link to="/dashboard" className="logo-small">
            <ImageWithBasePath src="assets/img/logo-small.png" alt="img" />
            {/* <img src={`data:image/png;base64,${userData?.companyLogo}`} alt="Logo" /> */}
          </Link>
          <Link
            id="toggle_btn"
            to={location.pathname + location.search}
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                  ? "none"
                  : "",
            }}
            onClick={handlesidebar}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to={location.pathname + location.search}
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Search */}
          <li className="nav-item nav-searchinputs" key="search"></li>
          {/* /Search */}
          <li
            className="nav-item dropdown has-arrow main-drop select-store-dropdown"
            key="company"
          >
            <Link
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <span className="user-name">
                {selectedCompanyCode === ALL_COMPANIES
                  ? "All Companies"
                  : companies.find((c) => c.companyCode === selectedCompanyCode)
                      ?.companyName}
              </span>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              {companies.map((company) => (
                <button
                  key={company.companyCode}
                  className="dropdown-item"
                  onClick={() => handleCompanyChange(company)}
                >
                  {company.companyName}
                </button>
              ))}
            </div>

            {/* {Array.isArray(companies) && companies?.length > 1 && (
                  <>
                    {companies
                      ?.filter(
                        (company) => company.companyCode === userData?.companyCode
                      )
                      ?.map((company) => {
                        return (
                          <Link
                            to={location.pathname + location.search}
                            className={`dropdown-toggle nav-link select-store key=${company.companyCode}`}
                            data-bs-toggle="dropdown"
                            key={company.companyCode}
                          >
                            <span className="user-info">
                              <span className="user-detail">
                                <span className="user-name">
                                  {company.companyName}
                                </span>
                              </span>
                            </span>
                          </Link>
                        );
                      })}
    
                    <div className="dropdown-menu dropdown-menu-right ">
                      {companies
                        ?.filter(
                          (company) => company.companyCode !== userData?.companyCode
                        )
                        ?.map((company) => (
                          <button
                            // to="#"
                            className="dropdown-item"
                            key={company.companyCode}
                            type="button"
                            // onClick={() =>
                            //   dispatch(changeLocation(location.locationCode))
                            // }
                            onClick={() =>
                              handleCompanyChange({
                                companyCode: company.companyCode,
                                companyName: company.companyName,
                              })
                            }
                          >
                            {company.companyName}
                          </button>
                        ))}
                    </div>
                  </>
                )} */}
          </li>

          <li
            className="nav-item dropdown has-arrow main-drop select-store-dropdown"
            key="location"
          >
            {Array.isArray(locations) && locations?.length > 1 && (
              <>
                {userData?.selectedLocationCode === "All" ? (
                  <Link
                    to={location.pathname + location.search}
                    className={`dropdown-toggle nav-link select-store key='all`}
                    data-bs-toggle="dropdown"
                    key="all"
                  >
                    <span className="user-info">
                      <span className="user-detail">
                        <span className="user-name">All Locations</span>
                      </span>
                    </span>
                  </Link>
                ) : (
                  locations
                    ?.filter(
                      (location) =>
                        location.locationCode ===
                        userData?.selectedLocationCode,
                    )
                    ?.map((location) => {
                      return (
                        <Link
                          to={location.pathname + location.search}
                          className={`dropdown-toggle nav-link select-store key=${location.locationCode}`}
                          data-bs-toggle="dropdown"
                          key={location.locationCode}
                        >
                          <span className="user-info">
                            <span className="user-detail">
                              <span className="user-name">
                                {location.locationName}
                              </span>
                            </span>
                          </span>
                        </Link>
                      );
                    })
                )}

                <div className="dropdown-menu dropdown-menu-right ">
                  {locations
                    ?.filter(
                      (location) =>
                        location.locationCode !==
                        userData?.selectedLocationCode,
                    )
                    ?.map((location) => (
                      <button
                        // to="#"
                        className="dropdown-item"
                        key={location.locationCode}
                        type="button"
                        // onClick={() =>
                        //   dispatch(changeLocation(location.locationCode))
                        // }
                        onClick={() =>
                          handleLocationChange(location.locationCode)
                        }
                      >
                        {location.locationName} - {location.locationCode}
                      </button>
                    ))}
                </div>
              </>
            )}
          </li>

          <li className="nav-item nav-item-box" key="fullscreen">
            <Link
              to={location.pathname + location.search}
              id="btnFullscreen"
              onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              {/* <i data-feather="maximize" /> */}
              <FeatherIcon icon="maximize" />
            </Link>
          </li>

          {/* Notification */}
          <li className="nav-item dropdown nav-item-box">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <Bell />
              {notifications?.length > 0 && (
                <span className="badge rounded-pill">
                  {notifications?.length}
                </span>
              )}
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                {notifications?.length > 0 && (
                  <Link
                    to="#"
                    className="clear-noti"
                    type="button"
                    onClick={clearAllNotifications}
                  >
                    {" "}
                    Clear All{" "}
                  </Link>
                )}
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  {notifications?.length > 0 ? (
                    notifications?.map((notification) => (
                      <li
                        className="notification-message"
                        key={notification.slno}
                      >
                        <Link to={getNotificationURL(notification?.type)}>
                          <div className="media d-flex">
                            <span className="avatar flex-shrink-0">
                              <Bell size={18} />
                            </span>
                            <div className="media-body flex-grow-1">
                              <p className="noti-details">
                                <span className="noti-title">
                                  {notification?.type}
                                </span>{" "}
                                {notification?.body}
                                {/* <span className="noti-title">
                                  Patient appointment booking
                                </span> */}
                              </p>
                              <p className="noti-time">
                                <span className="notification-time">
                                  {formatDistanceToNow(
                                    new Date(notification?.createDate),
                                    {
                                      addSuffix: true,
                                    },
                                  )}
                                </span>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                    ))
                  ) : (
                    <div className="text-center">No Notifications</div>
                  )}
                </ul>
              </div>
              {notifications?.length > 0 && (
                <div className="topnav-dropdown-footer">
                  <Link to={all_routes.notification_list}>
                    View all Notifications
                  </Link>
                </div>
              )}
            </div>
          </li>
          {/* Notification */}

          {/* <li className="nav-item nav-item-box">
                <Link to="/general-settings">
                  <FeatherIcon icon="settings" />
                </Link>
              </li> */}

          <li className="nav-item dropdown has-arrow main-drop" key="profile">
            <Link
              to={location.pathname + location.search}
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  <ImageWithBasePath
                    src="assets/img/user-profile.png"
                    alt="img"
                    className="img-fluid"
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">
                    {userData.userName?.toUpperCase()}
                  </span>
                  <span className="user-role">
                    {userData.userGroupCode?.toUpperCase()}
                  </span>
                </span>
              </span>
            </Link>

            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img">
                    <ImageWithBasePath
                      src="assets/img/user-profile.png"
                      alt="img"
                    />
                    <span className="status online" />
                  </span>
                  <div className="profilesets">
                    <h6>{userData.userName?.toUpperCase()}</h6>
                    <h5>{userData.userGroupCode?.toUpperCase()}</h5>
                  </div>
                </div>
                <hr className="m-0" />
                <Link
                  className="dropdown-item"
                  to={`${route.user}${route.user_profile}`}
                >
                  <i className="me-2" data-feather="user" /> My Profile
                </Link>
                {/* <Link
                      className="dropdown-item"
                      to={`${route.setting}${route.company_setting}`}
                    >
                      <i className="me-2" data-feather="settings" />
                      Settings
                    </Link> */}
                <hr className="m-0" />
                <button
                  className="dropdown-item logout pb-0 btn btn-link"
                  to={location.pathname + location.search}
                  onClick={handleLogout}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  Logout
                </button>
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to={location.pathname + location.search}
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to={`${route.user}${route.user_profile}`}
            >
              My Profile
            </Link>
            <Link
              className="dropdown-item"
              to={`${route.setting}${route.company_setting}`}
            >
              Settings
            </Link>
            <button
              className="dropdown-item btn btn-link"
              to={location.pathname + location.search}
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );

  // return (
  //   <div className="header">
  //     {/* Logo */}
  //     <div className={`header-left ${toggle ? "" : "active"}`}>
  //       <Link to="/dashboard" className="logo logo-normal">
  //         <ImageWithBasePath src="assets/img/logo.jpeg" />
  //       </Link>
  //       <Link id="toggle_btn" to="#" onClick={() => setToggle(!toggle)}>
  //         <FeatherIcon icon="chevrons-left" />
  //       </Link>
  //     </div>

  //     {/* Right Menu */}
  //     <ul className="nav user-menu">
  //       {/* COMPANY */}
  //       <li className="nav-item dropdown has-arrow">
  //         <Link className="dropdown-toggle nav-link" data-bs-toggle="dropdown">
  //           <span className="user-name">
  //             {selectedCompanyCode === ALL_COMPANIES
  //               ? "All Companies"
  //               : companies.find(c => c.companyCode === selectedCompanyCode)?.companyName}
  //           </span>
  //         </Link>
  //         <div className="dropdown-menu dropdown-menu-right">
  //           {companies.map(company => (
  //             <button
  //               key={company.companyCode}
  //               className="dropdown-item"
  //               onClick={() => handleCompanyChange(company)}
  //             >
  //               {company.companyName}
  //             </button>
  //           ))}
  //         </div>
  //       </li>

  //       {/* LOCATION */}
  //       <li className="nav-item dropdown has-arrow">
  //         <Link className="dropdown-toggle nav-link" data-bs-toggle="dropdown">
  //           <span className="user-name">
  //             {userData?.selectedLocationCode === "All"
  //               ? "All Locations"
  //               : locations.find(l => l.locationCode === userData?.selectedLocationCode)?.locationName}
  //           </span>
  //         </Link>
  //         <div className="dropdown-menu dropdown-menu-right">
  //           {locations.map(loc => (
  //             <button
  //               key={loc.locationCode}
  //               className="dropdown-item"
  //               onClick={() => handleLocationChange(loc.locationCode)}
  //             >
  //               {loc.locationName}
  //             </button>
  //           ))}
  //         </div>
  //       </li>

  //       {/* FULLSCREEN */}
  //       <li className="nav-item">
  //         <Link onClick={toggleFullscreen}>
  //           <FeatherIcon icon="maximize" />
  //         </Link>
  //       </li>

  //       {/* PROFILE */}
  //       <li className="nav-item dropdown has-arrow">
  //         <Link className="dropdown-toggle nav-link" data-bs-toggle="dropdown">
  //           <span className="user-name">{userData?.userName}</span>
  //         </Link>
  //         <div className="dropdown-menu">
  //           <button className="dropdown-item" onClick={handleLogout}>
  //             Logout
  //           </button>
  //         </div>
  //       </li>
  //     </ul>
  //   </div>
  // );
};

export default React.memo(Header);
